module.exports = __webpack_public_path__ + "static/img/skeleton_bg.e125962.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/skeleton_bg.png
// module id = lSom
// module chunks = 1